// extracted by mini-css-extract-plugin
export default {"Burger":"Burger_Burger__rirDe"};